import { render, staticRenderFns } from "./OPMTwoByTwo.vue?vue&type=template&id=744d8487&scoped=true&"
import script from "./OPMTwoByTwo.vue?vue&type=script&lang=js&"
export * from "./OPMTwoByTwo.vue?vue&type=script&lang=js&"
import style0 from "./OPMTwoByTwo.vue?vue&type=style&index=0&id=744d8487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d8487",
  null
  
)

export default component.exports